var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFloppyDisk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.29,32C23.9,32,0,55.9,0,85.29v266.43c0,29.39,23.9,53.29,53.29,53.29h266.43c29.39,0,53.29-23.9,53.29-53.29v-202.07c0-14.15-5.58-27.73-15.57-37.72l-64.36-64.36c-9.99-9.99-23.56-15.57-37.72-15.57H53.29ZM53.29,111.93c0-14.74,11.91-26.64,26.64-26.64h159.86c14.74,0,26.64,11.91,26.64,26.64v53.29c0,14.74-11.91,26.64-26.64,26.64H79.93c-14.74,0-26.64-11.91-26.64-26.64v-53.29ZM186.5,245.14c29.43,0,53.29,23.86,53.29,53.29s-23.86,53.29-53.29,53.29-53.29-23.86-53.29-53.29,23.86-53.29,53.29-53.29Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloppyDisk);
export default __webpack_public_path__ + "static/media/floppy-disk.730083ca727dbe963acb16f8ce88eb29.svg";
export { ForwardRef as ReactComponent };